import React from 'react';
import "./StyleCustomAlert.css"
import ButtonHint from "../Buttons/buttonHint/ButtonHint";

const CustomAlert = ({ title, message, statusCod, isOpenAlert, onClose, classAlertLoading, onConfirm, confirmText, cancelText }) => {
    if (!isOpenAlert) return null;

    return (
        <div className={`alert_wrapper ${isOpenAlert ? 'open' : ''}`}>
            <div className={`allert_container`}>
                <div className={`close_alert`} onClick={onClose}>+</div>
                <div className={`alert_wrapper_title`}>{title}</div>
                <div className={`${classAlertLoading}`}></div>
                <div className={`alert_wrapper_message`}>{message}</div>
                {statusCod && statusCod !== "confirm" && (statusCod < 200 || statusCod >= 300) && (
                    <div className={`alert_wrapper_status_cod`}>Код: {statusCod}</div>
                )}
                {statusCod === "confirm" && onConfirm && (
                    <div className="alert-buttons">
                        <ButtonHint funck={onClose} text={cancelText} className={"cancel"}/>
                        <ButtonHint funck={onConfirm} text={confirmText} className={"confirm"}/>
                    </div>
                )}
            </div>
        </div>
    );
};

export default CustomAlert;